var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-kng-operator",
    },
    [
      !_vm.loading
        ? [
            !_vm.removeUpload
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showUpload,
                        expression: "showUpload",
                      },
                    ],
                  },
                  [
                    _vm.mixinConfig.enable &&
                    !_vm.mixinConfig.onlyPrivate &&
                    _vm.module !== "kng"
                      ? _c(
                          "div",
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pc_biz_lbl_storeposition" /**请选择存储位置 */
                                  )
                                )
                              ),
                            ]),
                            _c(
                              "yxt-radio-group",
                              {
                                model: {
                                  value: _vm.uploadConfig.privateEnv,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.uploadConfig,
                                      "privateEnv",
                                      $$v
                                    )
                                  },
                                  expression: "uploadConfig.privateEnv",
                                },
                              },
                              [
                                _c("yxt-radio", { attrs: { label: 0 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "pc_kng_courseware_lbl_public_cloud" /**公有云 */
                                      )
                                    )
                                  ),
                                ]),
                                _c("yxt-radio", { attrs: { label: 1 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "pc_biz_kng_tip_localCloud" /**私有云 */
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.uploadConfig.privateEnv &&
                    _vm.mixinConfig.serveGroupList.length &&
                    !(
                      !!_vm.uploadConfig.privateEnv &&
                      !_vm.uploadConfig.usable &&
                      _vm.module === "kng"
                    )
                      ? _c(
                          "div",
                          { staticClass: "yxtbiz-kng-operator__serve mt8" },
                          [
                            _c(
                              "yxt-radio-group",
                              {
                                model: {
                                  value: _vm.uploadConfig.serverGroupId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.uploadConfig,
                                      "serverGroupId",
                                      $$v
                                    )
                                  },
                                  expression: "uploadConfig.serverGroupId",
                                },
                              },
                              _vm._l(
                                _vm.mixinConfig.serveGroupList,
                                function (item) {
                                  return _c(
                                    "yxt-radio",
                                    { key: item.id, attrs: { label: item.id } },
                                    [
                                      _vm._v(
                                        _vm._s(item.serviceGroupName) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "yxtbiz-kng-operator__upload" },
                      [
                        !!_vm.uploadConfig.privateEnv &&
                        !_vm.uploadConfig.usable &&
                        _vm.module === "kng"
                          ? [
                              _c("yxtf-empty", { attrs: { permission: "" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "standard-size-20 color-gray-9 mt24",
                                    attrs: { slot: "text" },
                                    slot: "text",
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "pc_kng_courseware_msg_connect_to_server" /** 无法连接到服务器 */
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "pc_kng_courseware_msg_check_server_started" /** 如需访问请联系管理人员，检查服务器是否启动 */
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          : [
                              _c("kng-upload", {
                                attrs: {
                                  isPrivate: !!_vm.uploadConfig.privateEnv,
                                  serverGroupId: _vm.uploadConfig.serverGroupId,
                                  disabled:
                                    !!_vm.uploadConfig.privateEnv &&
                                    !_vm.uploadConfig.usable,
                                  "special-upload": _vm.isSpecialUpload,
                                  specialFileType: _vm.isSpecialUpload
                                    ? _vm.createFileType
                                    : "",
                                  max: 10 - _vm.infoList.length,
                                },
                                on: {
                                  add: _vm.onAdd,
                                  reupload: _vm.reupload,
                                  update: _vm.onUpdate,
                                },
                              }),
                              !_vm.isSpecialUpload
                                ? _c("kng-upload-tips", {
                                    attrs: {
                                      enableUploadZip: _vm.enableUploadZip,
                                      module: _vm.module,
                                    },
                                  })
                                : _vm._e(),
                            ],
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            !_vm.showUpload
              ? [
                  _vm.multiple
                    ? _c("kng-form-multi", {
                        ref: "form",
                        attrs: { infoList: _vm.infoList },
                        on: {
                          continueUpload: _vm.continueUpload,
                          delete: _vm.del,
                        },
                      })
                    : _vm.infoList.length === 1
                    ? _c("kng-form-single", {
                        ref: "form",
                        attrs: { info: _vm.infoList[0] },
                        on: { delete: _vm.del },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.showWeiKeSelector
        ? _c("wei-ke-selector", { ref: "selector" })
        : _vm._e(),
      _vm.showKngLibSelector
        ? _c("kng-lib-selector", { ref: "selector" })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }